import { AgGridReact } from "ag-grid-react";
import React, { useEffect, useState } from "react";
import { groupdelete, grouplist } from "../../../services/admin";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { isAdmin } from "../../../utils/roles";

export default function Allgroup() {
  const [filterProduct, setFilterProduct] = useState([]);
  const navigate=useNavigate();
  const columnDefs = [
    {
      headerName: "Actions",
      field: "id",
      width: 150,
      sortable: true,
      resizable: true,
      filter: false,
      floatingFilter: false,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            <a className="btn-sm btn-info me-2" onClick={() => navigate(`/group/groupdetail/${params.value}`)}>
              <i className="fa fa-edit"></i>
            </a>
            {isAdmin() &&
   <a
              className="btn-sm btn-danger me-2"
              onClick={() => grpdelete(params.value)}
            >
              <i className="fa fa-trash"></i>
            </a>
            }
         
          </div>
        );
      },
    },
    {
      headerName: "Group ID",
      field: "group_id",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Group Name",
      field: "group_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    // {
    //   headerName: "Total Members",
    //   field: "total_members",
    //   sortable: true,
    //   resizable: true,
    //   filter: true,
    //   floatingFilter: true,
    //   cellStyle: { textAlign: "left" },
    // },
    {
      headerName: "Due On",
      field: "group_due",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Collection Day",
      field: "group_collection_day",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Staff",
      field: "staff_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Branch",
      field: "branch_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Center",
      field: "group_center",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Time",
      field: "group_time",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
  ];

  useEffect(() => {
   funlist();
  }, []);

  function funlist() {
    setFilterProduct([]);
    const temp=new FormData();
    temp.append("branch", localStorage.getItem("branch"));
    grouplist(temp).then((res) => {
        if (res.status === true) {
          setFilterProduct(res.data);
        }
      });
  }
  function grpdelete(gid) {
    Swal.fire({
      text: "Are you sure want to delete?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#ac0404",
      cancelButtonColor: "#6259ca",
      confirmButtonText: "Delete",
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        groupdelete(gid).then((response) => {
          if (response.status === true) {
            toast.success(response.message);
            funlist();
          }else{
            Swal.fire({
                text: response.message,
                icon: "warning",
                showCancelButton: false,
                confirmButtonColor: "#008000",
                confirmButtonText: "Ok",
                allowOutsideClick: false,
              });
          }
        })
      
      }
    });
  }

  return (
    <div>
      <div className="page-header">
        <h2 className="main-content-title tx-24 mg-b-5">All Group</h2>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>Group</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            All Group
          </li>
        </ol>
      </div>

      <div className="content-body">
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-header">
                <h2 className="main-content-title tx-24 mg-b-5">
                  All Group Detail
                </h2>
              </div>
              <div className="card-body">
                <div className="ag-theme-alpine ag-style mt-2">
                  <AgGridReact
                    columnDefs={columnDefs}
                    rowData={filterProduct}
                    pagination="true"
                    paginationPageSize="10"
                    sortingOrder={["asc", "desc"]}
                    suppressDragLeaveHidesColumns={true}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
